import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { VersionCheckService, VersionInfo } from '@completion/services';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-about-dialog',
  standalone: false,
  templateUrl: './about-dialog.component.html',
  styleUrls: ['./about-dialog.component.scss'],
})
export class AboutDialogComponent implements OnInit {
  versionInfo: VersionInfo | null = null;

  constructor(
    private readonly dialogRef: MatDialogRef<AboutDialogComponent>,
    private readonly versionCheck: VersionCheckService,
    private readonly http: HttpClient,
  ) {}

  ngOnInit(): void {
    // Try the cached version first, otherwise fetch fresh
    this.versionInfo = this.versionCheck.getCurrentVersion();
    if (!this.versionInfo) {
      this.fetchVersion();
    }
  }

  private async fetchVersion(): Promise<void> {
    try {
      this.versionInfo = await firstValueFrom(this.http.get<VersionInfo>(`/version.json?t=${Date.now()}`));
    } catch {
      this.versionInfo = { version: 'unknown', hash: 'unknown' };
    }
  }
}
